/* eslint-disable indent */
class SideTabs {
	constructor(el) {
		this.el = el;
		this.tabs = this.el.querySelectorAll('.block-side-tabs__tab');
		this.tabContentContainer = this.el.querySelectorAll('.block-side-tabs__tab-content-container');
		this.tabContent = this.el.querySelectorAll('.block-side-tabs__tab-content');
		this.tabContentTitle = this.el.querySelectorAll('.block-side-tabs__tab-content-title-mobile');
		this.currentMode = null; // "desktop" o "mobile"

		this.init();

		window.addEventListener('resize', this.onResize);
	}

	init = () => {
		const isDesktop = window.innerWidth > 768;
		const newMode = isDesktop ? 'desktop' : 'mobile';

		// If the mode hasn't changed, do nothing
		if (this.currentMode === newMode) return;

		// Remove previous listeners before switching modes
		this.removeAllListeners();

		// Initialize according to mode
		if (isDesktop) {
			this.initDesktop();
		} else {
			this.initMobile();
		}

		this.currentMode = newMode;
	};

	onResize = () => {
		this.init();
	};

	removeAllListeners = () => {
		// Clone nodes to remove all previously attached event listeners
		this.tabs.forEach((tab) => {
			const newTab = tab.cloneNode(true);
			tab.parentNode.replaceChild(newTab, tab);
		});

		this.tabContentContainer.forEach((tabContent) => {
			const newContent = tabContent.cloneNode(true);
			tabContent.parentNode.replaceChild(newContent, tabContent);
		});

		// Reassign updated element references
		this.tabs = this.el.querySelectorAll('.block-side-tabs__tab');
		this.tabContentContainer = this.el.querySelectorAll('.block-side-tabs__tab-content-container');
	};

	initDesktop = () => {
		// Check if there is any active content
		const activeContent = [...this.tabContentContainer].find((content) =>
			content.classList.contains('active')
		);
	
		// If no active content, activate the first tab by default
		if (!activeContent && this.tabContentContainer.length > 0 && this.tabs.length > 0) {
			this.tabContentContainer[0].classList.add('active');
			this.tabs[0].classList.add('active');
		} else if (activeContent) {
			//If there is active content, synchronize the corresponding tab
			const activeIndex = activeContent.dataset.index;
	
			this.tabs.forEach((tab) => {
				tab.classList.toggle('active', tab.dataset.index === activeIndex);
			});
		}
	
		// Add click listeners for tab switching
		this.tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				const index = tab.dataset.index;
	
				this.tabContentContainer.forEach((content) => {
					content.classList.toggle('active', content.dataset.index === index);
				});
	
				this.tabs.forEach((t) => {
					t.classList.toggle('active', t.dataset.index === index);
				});
			});
		});
	};
	

	initMobile = () => {
		this.tabContentContainer.forEach((tabContent) => {
			const title = tabContent.querySelector('.block-side-tabs__tabs-container-mobile');
			if (!title) return;

			title.addEventListener('click', () => {
				const isActive = tabContent.classList.contains('active');

				this.tabContentContainer.forEach((c) => c.classList.remove('active'));

				if (!isActive) {
					tabContent.classList.add('active');
				}
			});
		});
	};
}

export default SideTabs;
